import { signal } from '@angular/core';
import { AnnotationRow, Claim } from './types';

/** Minimal read surface the overlay directive needs from an annotation provider. */
export interface OverlayAnnotationSource {
  annotations(): AnnotationRow[];
  selectedAnnotationId(): string | null;
}

/** Minimal read surface the overlay directive needs from a claim provider. */
export interface OverlayClaimSource {
  getForDocument(documentId: string): Claim[];
}

/** Static, read-only annotation source backed by a signal of rows. */
export class StaticOverlayAnnotationSource implements OverlayAnnotationSource {
  private rows = signal<AnnotationRow[]>([]);
  annotations = () => this.rows();
  selectedAnnotationId = () => null;
  set(rows: AnnotationRow[]): void {
    this.rows.set(rows);
  }
}

/** Static, read-only claim source returning the same claims for any document. */
export class StaticOverlayClaimSource implements OverlayClaimSource {
  private claims: Claim[] = [];
  set(claims: Claim[]): void {
    this.claims = claims;
  }
  getForDocument(_documentId: string): Claim[] {
    return this.claims;
  }
}
